export const locale = {
  lang: "en",
  data: {
    LABELS: {
      others: {
        updateRequired: "Update Required",
        updateAppMessage: " A new version of the app is available, please update to access.",
        noCustomerFound: "No customer found",
        kirloSmart: "KirloSmart",
        subTitle: "Pump Health, Digitally Simplified",
        justNow: "Just Now",
        viewDetails: "View Details",
        retry: "Retry",
        live: "LIVE",
        offline: "OFFLINE",
        monthInitial: "M",
        noCancel: "No, Cancel",
        yesMute: "Yes, Mute",
        no: "No",
        yes: "Yes",
        liveStreaming: "Live Streaming",
        filters: "Filters",
        problem: "Problem",
        cause: "Cause",
        attachments: "Attachments",
        inComingSoonMsg: "We are working hard to get this up  & running.",
        availableSoon: "It will be available soon!",
        selected: "Selected",
        period7D: "7D",
        period1M: "1M",
        period6M: "6M",
        period1Y: "1Y",
        selectAll: "select all",
        noMatching: "No matching",
        found: "found",
        inactive: "Inactive",
        PumpsandSystems: "Pumps & Systems",
        PumpMasters: "Pump Masters",
        SystemMasters: "System Masters",
        download: "Download",
      },
      dashboard: {
        overdue: "Overdue",
        dueIn2Months: "Due in 2 months",
        replacementDueOn: "Replacement Due On",
        adsNotAvailable: "Ads not available",
        overview: "Overview",
        All: "Total Pumps",
        NeedAttentionRunning: "Need Attention - Running",
        NeedAttentionIdle: "Need Attention - Idle",
        HealthyRunning: "Healthy - Running",
        HealthyIdle: "Healthy - Idle",
        DeviceDisconnected: "Device Disconnected",
        Customers: "Customers",
        Sites: "Sites",
        sites: "Sites",
        masters: "Masters",
        Alerts: "Alerts",
        Alarms: "Alarms",
        footerImage: "english",
        AllSites: "All Sites",
        SiteAnalytics: "Site Analytics",
        Last7Days: "(Last 7 Days)",
        customerDrawer: {
          sortBy: "Sort By",
          zone: "Zone",
        },
        noPumpAvailable: {
          needAttentionRunning: "Looks like there are no 'Need Attention - Running' pumps.",
          needAttentionIdle: "Looks like there are no 'Need Attention - Idle' pumps.",
          deviceDisconnected: "Looks like there are no 'Device Disconnected' pumps.",
          healthyRunning:"Looks like there are no 'Healthy - Running' pumps.",
          healthyIdle:"Looks like there are no 'Healthy - Idle' pumps.",
        },
        sparesDemand: "Spares Demand",
        country: "COUNTRY",
        zones: "ZONES",
        high: "High",
        low: "Low",
        search: "Search",
        pumpModels: "PUMP MODELS",
        pumpType: "PUMP TYPE",
        customers: "Customers",
        pumpAndSystemTypes: "PUMP & SYSTEM TYPES",
        pumpAndSystemModels: "PUMP & SYSTEM MODELS",
        topCauses: "Top Causes",
      },
      user: {
        all:"All",
        active: "Active",
        deactive: "Deactivated",
        status: "Status",
      },
      pump: {
        Energy:"Energy Saving",
        healthy: "Healthy",
        kirloSmart: "KirloSmart",
        subTitle: "Pump Health, Digitally Simplified",
        pump: "Pump",
        system: "System",
        innerPump: "Inner Pump",
        Pump: "Pump",
        System: "System",
        alarmingValue: "Tripping",
        alarmingText: "Display Value",
        digitalParameters: "Digital Parameters",
        healthyText: "Display Value",
        PumpMaster: "Pump Master",
        SystemMaster: "System Master",
        active: "Active",
        deactivated: "Deactivated",

        updatedAt: "Updated on",
        maintenance: "Maintenance",
        switchOnPump: "Switch On Pump",
        switchOffPump: "Switch Off Pump",
        complaintRaised: "Complaint raised",
        lastServiced: "Last serviced",
        nextServicing: "Next Servicing",
        // mttr: 'MTTR',
        // mtbf: 'MTBF',
        sensorKey: "Sensor Key",
        totalRunHours: "Total Run Hours",
        RunHoursForCurrentMonth: "Run Hours for Current Month",
        runHours: "Run Hours",
        mfgDate: "Mfg Date",
        strengthAndConsumption: "Strength & Consumption",
        servicing: "Servicing",
        other: "Other",
        pumpSwitchOff: "Pump Switched Off",
        warranty: "Warranty",
        warrantyDate: "KirloSmart Device Warranty",
        pumps: "Pumps",
        systemType: "System Type",
        contactDetails: "Contact Details",
        engineDetails: "Engine Details",
        gearBoxDetails: "Gear Box Details",
        motorDetails: "Motor Details",
        pumpDetails: "Pump Details",
        systemDetails: "System Details",
        siteDetails: "Site Details",
        alerts: "Alerts",
        causeMetricsConditions: "Cause Matrix Conditions",
        alarm: "Alarm",
        upcomingMaintenance: "Upcoming Maintenance",
        alarms: "Alarms",
        replace: "Replace",
        by: "by",

        dueForReplacementBy: "due for replacement by",
        serviceParameters: "Service Parameters",
        till: "till",
        expiredOn: "Expired on",
        triggerValue: "Trigger Value",
        runCounter: "Run Counter",
        availablePumps: "Available Pumps",
        selectedPumps: "Selected Pumps",
        customers: "Customers",
        customer: "Customer",
        selectCustomer: "Select Customer",
        all: "All",
        home: "Home",
        complaints: "Complaints",
        mySite: "My Sites",
        member: "Members",
        subscription: "Subscriptions",
        help: "Help",
        tag: "Tag",
        alertAlarm: "Alerts & Alarms",
        type: "Type",

        tripping: "Tripping",
        healthyValue: "Healthy",
        serialNumber: "Serial Number",
        signal: "Signal",
        energy: "Energy",
        pumpType: "Pump Type",
        pumpNumber: "Pump Number",
        oaNumber: "OA Number",
        flow: "Flow",
        flowWithUnit: "Flow (m3/hr)",
        totalHead: "Total Head",
        totalHeadWithUnit: "Total Head (m)",
        driverRating: "Driver Rating",
        nonSensorKey: "NON-SENSOR KEY",
        discharge: "Discharge",
        pumpInputPower: "Pump Input Power",
        pumpInputPowerWithUnit: "Pump Input Power (kW)",
        impellerDiameter: "Impeller Diameter",
        impellerDiameterWithUnit: "Impeller Diameter (mm)",
        matCode: "MAT Code",
        size: "Size",
        speed: "Speed",
        speedWithUnit: "Speed (rpm)",
        suctionDeliveryPipeSize: "Suction/ Delivery Pipe Size",
        suctionDeliveryPipeSizeWithUnit: "Suction/ Delivery Pipe Size (mm)",
        specificGravity: "Specific Gravity",
        flowEstimationFactor: "Flow Estimation Factor",
        manufacturingDate: "Mfg Date",
        invoiceNumber: "Invoice Number",
        invoiceDate: "Invoice Date",
        lastServiceOn: "Last serviced On",
        nextServiceOn: "Next Servicing On",
        subscriptionExpired: "Subscription Valid Till",
        subscriptionDueOn: "Subscription Due On",
        subscriptionDueDate: "Subscription due date",
        modelNumber: "Model Number",
        modelName: "Model Name",
        model: "Model",
        rating: "Rating",
        off: "OFF",
        on: "ON",
        remote: "Remote",
        capitalizeOff: "Off",
        capitalizeOn: "On",
        make: "Make",
        mcNumber: "M/C Number",
        frame: "Frame",
        frameSizeOrMounting: "Frame Size / Mounting",
        kWHP: "kW (HP)",
        rpm: "RPM",
        volt: "Volt",
        voltage: "Voltage",
        energyRate: "Energy Rate",
        voltageWithUnit: "Voltage (V)",
        current: "Current",
        currentWithUnit: "Current (A)",
        frequency: "Frequency",
        frequencyWithUnit: "Frequency (Hz)",
        inGraceProtection: "Ingrace Protection",
        duty: "Duty",
        powerFactor: "Power Factor",
        efficiency: "Efficiency",
        amp: "AMP",
        ratedFrequency: "Rated Frequency",
        engineNumber: "Engine Number",
        engineModel: "Engine Model",
        governorType: "Governor Type",
        seeMore: "See More",
        seeLess: "See Less",
        application: "Application",
        liquidMedia: "Liquid/ Media",
        installationDate: "Pump Installation Date",
        kirlosmartInstallationDate: "KirloSmart Installation Date",
        requestQuote: "Request Quote",
        resolve: "Resolve",
        markAsResolve: "Mark As Resolve",
        subscriptionExpiry: "Subscription Expiry",
        subscriptionExpiryDate: "Subscription Expiry Date",
        more: "More",
        media: "Media",
        pumpModelWith: "Pump Model with",
        motorType: "Motor Type",
        engineType: "Engine Type",
        frameSizeMounting: "Frame Size/ Mounting",
        standardMTTR: "Standard MTTR",
        standardMTBF: "Standard MTBF",
        servicingAfterRunHours: "Servicing After Run Hours (hrs)",
        servicingAfterMonths: "Servicing After Months (no. of months)",
        noAlertsMessage:
          "No alerts, your pump is working fine! Sit back & relax.",
        noMaintenancesMessage:
          "No upcoming maintenance alarms! Sit back & relax",
        dials: "Dials",
        unableToLoadData: "Unable to load data",
        power: "Power",
        powerWithUnit: "Power (kW)",
        powerWithUnitHp: "Power (hp)",
        switchPumpOff: "Switch Pump Off?",
        takeControlOfThisFunctionality: "Take control  of this functionality",
        togglePumpMessage:
          "If you select option of “switch off”, only you will have the control to switch the pump On; And no other users will have this control.",
        reason: "Reason",
        switchOff: "Switch Off",
        hello: "Hello",
        welcomeToKirlosmart: "Welcome to KirloSmart",
        overview: "Overview",
        seeAll: "See All",
        healthyRange: "Healthy range",
        Digitalhealthy: "Healthy",
        calibration: "Calibration",
        viewOnMap: "View on Map",
        variableParameter: "Variable Parameter",
        digitalParameter: "Digital Parameter",
        alarming: "Alarming",

        parameters: "Parameters",
        year: "Year",
        generateCustomReports: "Generate Custom Reports",
        report: "Reports",
        yourCurrentLocation: "Your Current Location",
        cantLoadYourMapCheckYourInternetConnection:
          "Unalbe to load Map check Your Internet connection",
        idleSince: "Idle Since",
        spares: "Spares",
        trendGraphs: "Trend Graphs",
        mimicImage: "Mimic Image",
        lastReplaced: "Last Replaced",
        nextProbableReplacement: "Next Probable Replacement",
        extendedTriggerValue: "Extended Trigger Value",
        standardTriggerValue: "Standard Trigger Value",
        userSetValue: "User Set Value",
        EditUserSetValue: "Edit User Set Value",
        EditSpareRunCounter: "Edit Spare Run Counter",
        spare: "Spare",
        triggerValueForHighAlarms: "Trigger Value for High Alarms",
        triggerValueForMediumAlarms: "Trigger Value for Medium Alarms",
        extendByHours: "Extend by (hrs)",
        highAlarmsFrequency: "High Alarms Frequency (hrs)",
        mediumAlarmsFrequency: "Medium Alarms Frequency (hrs)",
        hours: "hrs",
        alarmingConditionRanges: "Alarming Condition Ranges",
        notificationDelay: "Notification Delay",
        notificationFrequency: "Notification Frequency",
        notificationFrequencyHours: "Notification Frequency (hrs)",
        trippingConditionRanges: "Tripping Condition Ranges",
        withMaterial: "With Material",
        withoutMaterial: "Without Material",
        description: "Description",
        servicedOn: "Serviced On",
        ifPumpWasServicedDuringResolution:
          "If pump was serviced during resolution",
        complaintRaisedFor: "Complaint raised for ",
        searchBNameModelTagCustomerSite:
          "Search by pump name, model, tag, customer, site",
        startFrom: "Start From",
        format: "Report Format",
        excel: "Excel",
        daily: "Daily",
        weekly: "Weekly",
        fortNight: "Fortnight",
        monthly: "Monthly",
        reportsSchedule: "Reports Schedule",
        getReports: "Get reports at selected time & time interval.",
        showAlert: "Show generated alerts in the reports",
        showAlarm: "Show generated alarms in the reports",
        reportsParameters: "Parameters in the Report",
        emailMessage: "Email Message",
        save: "Save",
        saveReport: "Save Report",
        downloading: "Downloading...",
        selectParameters:
          "Select the parameters & rearrange their sequence that have to appear in the reports",
        resetToDefault: "Reset to Default",
        cause: "Cause : ",
        noSensorKeyData:
          "No parameter available as pump does not have sensor key",
        pumpSubscriptionExpiredMessage:
          "The KirloSmart subscription has expired. To continue viewing further, please contact your administrator.",
        systemSubscriptionExpiredMessage:
          "The KirloSmart subscription has expired. To continue viewing further, please contact your administrator.",
        pumpExpireMessage: "More details not available as pump is expired",
        systemExpireMessage: "More details not available as system is expired",
        nonSensorKeyPump:
          "Data is not available as the pump does not have a sensor Key",
        nonSensorKeySystem:
          "Data is not available as the system does not have a sensor Key",
        pumpRunHours: "Pump Run Hours",
        noPump: "pumps / systems",
        customReport: "Send Custom Report",
        sendNow: "Send Now",
        cancel: "Cancel",
        requestQuoteFor: "Request Quote for",
        request: "Request",
        notActive: "Not Active",
        looksLikeThereAreNoPumpsSystem:
          "Looks like there are no pumps / systems",
        oopsNoDataFound: "Oops...No data found.",
        sending: "Sending...",
        subscriptionExpiredOn: "Subscription Expired",
        requestQuoteOfSpare: "Spares Of",
        engineElectricalSystem: "Electrical System",
        engineElectricalSystemWithUnit: "Electrical System (V DC)",
        engineFuel: "Engine Fuel",
        engineCoolantGrade: "Coolant Grade",
        engineCoolantCapacity: "Coolant Capacity",
        engineCoolantCapacityWithUnit: "Coolant Capacity (Litre)",
        engineOilGrade: "Oil Grade",
        engineOilCapacity: "Oil Capacity",
        engineOilCapacityWithUnit: "Oil Capacity (Litre)",
        engineListing: "Listing",
        gearMakeModel: "Make/Model",
        gearServiceRating: "Service Rating",
        gearServiceFactor: "Service Factor",
        gearRatio: "Ratio",
        medium: 'Medium',
        large: 'Large',
        small: 'Small',
        configureView: 'Configure View',
        cardView: 'Card View',
        dialView: 'Dial View',
        defaultView: 'Default View',
        cardSize: 'Card Size',
        showTrend: 'Show Trend',
        editPumpTotalRunHours: 'Edit Pump Total Run Hours',

        muteNotifications: {
          done: "Done",
          muteNotificationDescription:
            "You will not receive SMS, Emails & Push notifications for the selected period.",
          sevenDays: "7 days",
          day: "24 hrs",
          fourHours: "4 hrs",
          muteForPeriod: "Mute For Period",
          muteForAlert: "Mute For Alert",
          muteForAlarm: "Mute For Alarm",
          muteNotification: "Mute Notifications",
        },
        pumpList: {
          no: "No",
          available: "Available",
        },
        to: "to",

        looksLikeThereAreNoPumps: "Looks like there are no ",
        TotalHead: "Total head",
        FullLoadCurrent: "Full load Current (FLC)",
        RatedFlow: "Rated flow",
        MotorKW: "Motor KW",
        MotorSpeed: "Motor speed",
        motorVoltage: "Motor Voltage",
        motorFrequency: "Motor Frequency",
        pumpSystem: "Pump/System",
        customerAndSite: "Customer & Site",
        status: "Status",
        pumpAndSystem: "Pumps & Systems",
        warrantyExpired: "Warranty Expired",
        site: "Site",
        showPumps: "Show {length} Pumps",
        weeklyReportGenerationDay: 'Weekly Report Generation Day',
        statusAndRuncounter: "Status / Run Counter",
      },
      pumpRemark: {
        publishRemark: {
          noLabel: "No, Cancel",
          yesLabel: "Yes, Publish",
        },
        addRemark: {
          system: "System",
          remarkFor: "Remark For",
          remark: "Remark",
          add: "Add",
        },
        listing: {
          title: "Remarks",
          published: "Published",
          addedBy: "Added By:",
          publishedBy: "Published By:",
          selected: "Selected",
          addNewRemark: "Add New Remark",
          cancel: "Cancel",
          publishSelected: "Publish Selected",
          noRemark: "No remark added yet",
        },
      },
      auth: {
        login: "Login",
        logout: "Logout",
        email: "Email",
        password: "Password",
        setPassword: "Set Password",
        resetPassword: "Reset Password",
        confirmPassword: "Confirm Password",
        forgotPassword: "Forgot Password?",
        setYourPassword: "Set your password",
        language: "Language",
        continue: "Continue",
        changePassword: "Change Password",
        oldPassword: "Old Password",
        newPassword: "New Password",
        confirmNewPassword: "Confirm New Password",
        verification: "Verification",
        changeEmail: "Change Email",
        verify: "Verify",
      },
      kebabMenu: {
        viewRemedy: "View Remedy",
        raiseComplaint: "Raise Complaint",
        resolve: "Resolve",
        muteNotifications: "Mute Notifications",
        scheduleMaintenance: "Schedule Maintenance",
        parameters: "Parameters",
        spares: "Spares",
        EnergySaving: "Energy Saving",
        activityLog: "Activity Log",
        remarks: "Remarks",
        reports: "Reports",
        addTagOrEditTag: "Add Tag or Edit Tag",
        addTag: "Add Tag",
        editTag: "Edit Tag",
        help: "Help",
        moreOptions: "More Options",
        viewAndEdit: "View And Edit",
        duplicate: "Duplicate",
        delete: "Delete",
        inactivate: "Inactivate",
        activate: "Activate",
        deactivate: "Deactivate",
        suspended: "Suspended",
        suspend: "Suspend",
        moveUp: "Move Up",
        moveDown: "Move Down",
        moveToTop: "Move to Top",
        moveToBottom: "Move to Bottom",
        resetRunCounter: "Reset Run Counter",
        editUserSetValue: "Edit User Set Value",
        editSpareRunCounter: "Edit Spare Run Counter",
        extendTriggerValue: "Extend Trigger Value",
        editPumpMaster: "Edit Pump Master",
      },
      parameter: {
        edit: "Edit",
        save: "Save",
        from: "From",
        to: "To",
        view: "View",
        notificationDelay: "Notification Delay",
        notificationFrequency: "Notification Frequency",
        muteNotifications: "Mute Notification",
        hrs: "hrs",
        days: "days",
        lowestAlarmingValue: "Lowest Alarming Value",
        highestAlarmingValue: "Highest Alarming Value",
        range: "Range",
        raisedOn: "Raised on",
        resolvedOn: "Resolved on",
        singleValue: "Single Value",
        oneHour: "1 Hr",
        oneDay: "24 Hr",
        sevenDays: "7 D",
        oneMonth: "1 M",
        custom: "Custom",
        customParameterTrend: "Custom Parameter Trend",
        EnergySavingTrend: "Custom Energy Saving Trend",
        viewTrend: "View Trend",
        outOfRange: "Out of range",
        altizonKey: "Altizon Key",
        cloudAttribute: "Cloud Attribute",
        cloudAttributeValid: "Cloud Attribute Valid",
        this: "this",
      },
      help: {
        addNew: "Add New",
        help: "Help",
        faq: "FAQs",
        faqSearch: "FAQs Search",
        search: "Search",
        noData: "No data available",
        loading: "Loading Results...",
        seeLess: "See Less",
        seeMore: "See More",
        language: "Language",
        installationGuide: "Installation Guides",
        iomProductBrochure: "Product Brochures",
        troubleshooting: "Troubleshooting",
        trouble: "Trouble",
        symptom: "Symptom/ Cause",
        cause: "Cause",
        remedy: "Remedy",
        attachments: "Attachments",
        pumpInstallationProcess: "Get full installation process of pump",
        informationOfKBLProducts: "Get to know about KBL products",
        resolutionForProblem: "Resolutions for most common problems",
        getAnswerToYourQuestion: "Get answers to your questions",
        dontFindAnything: "If you don't find what you are looking for, visit",
        selectLanguageOfInstallationGuide:
          "Select language of installation guide",
        selectLanguageOfProductBrochure: "Select language of product Brochure",
        otherDocuments: "Other Documents",
        otherUsefulDocumentsOfPump: "Other useful documents of pump",
        productBrochure: "Product Brochure",
        helloHowCanWeHelp: "Hello, how can we help you?",
        guides: "Guides",
        kirloskarEndSuctionPumps: "Kirloskar End Suction Pumps",
        iomDocuments: "IOM Documents",
        etc: "etc",
      },
      action: {
        save: "Save",
        back: "Back",
        yes: "Yes",
        no: "No",
        done: "Done",
        addNew: "Add New",
        active: "Active",
        status: "Status",
        cancel: "Cancel",
        duplicate: "Duplicate",
        add: "Add",
        update: "Update",
        edit: "Edit",
        addNewParameter: "Add New Parameter",
        VariableParameter: "Add Variable Parameter",
        DigitalParameter: " Add Digital Parameter",
        editParameter: "Edit Parameter",
        addNewSpares: "Add New Spares",
        saveAsDraft: "Save As Draft",
        previous: "Previous",
        next: "Next",
        preview: "Preview",
        uploadImages: "Upload Images",
        browse: "Browse",
        others: "Others",
        remove: "Remove",
        backToLogin: "Back To Login",
        sendResetLink: "Send Reset Link",
        clearAll: "Clear All"
      },
      admin: {
        displayText: " Display Text",
        healthyValue: "Healthy",
        alarmingValue: "Tripping ",
        zero: "0",
        one: "1",
        approve: "Approve",
        autoEmailReport: "Auto Email Report",
        disableAlarmNotification: "Disable Alarm notifications",
        disableAlertNotification: "Disable Alert notifications",
        disableStatusUpdateNotification: "Disable Status Update notifications",
        reject: "Reject",
        editFaq: "View and Edit",
        serialNo: "Serial No",
        sensorKey: "Sensor Key",
        motor: "Motor",
        engine: "Engine",
        kbl: "KBL",
        nonKbl: "Non-KBL",
        customerAndSites: "Customer & Sites",
        customerAndSitesDetails: "Customer & Sites Details",
        customerSites: "Customer Sites",
        customerAdmin: "Customer Admin",
        customer: "Customer",
        customerAdminDetails: "Customer Admin Details",
        site: "Site",
        admin: "Admin",
        selectCauses: "Select Cause",
        selectRemedy: "Select Remedy",
        addNewCauses: "Add New Cause",
        addNewRemedy: "Add New Remedy",
        autoRefreshInterval: "Auto-refresh interval (mins)",
        zonalCoordinator: "Zonal Coordinator",
        serviceEngineer: "Service Engineer",
        kblServiceEngineer: "KBL Service Engineer",
        switchRoles: "Switch Roles",
        noOfPumps: "No. of Pumps",
        timezone: "Timezone",
        address: "Address",
        updatedOn: "Updated On",
        updatedBy: "Updated By",
        // updatedOnAndUpdatedBy: "Updated By / Updated On",
        clear: "Clear",
        validOption: "Valid option",
        inValidOption: "Invalid option",
        userName: "User Name",
        role: "Role",
        roles: "Roles",
        mobileNumber: "Mobile Number",
        phoneNumber: "Phone Number",
        alternatePhoneNumber: "Alternate Phone Number",
        createdOn: "Created On",
        uploadedBy: "Updated By",
        addUser: "Add User",
        addRoles: "Add Role",
        editRoles: "Edit Role",
        roleTitle: "Role Title",
        accessRights: "Access Rights",
        editUser: "Edit User",
        duplicateUser: "Duplicate User",
        rights: "Rights",
        assignDownload: "Assign/ Download",
        name: "Name",
        email: "Email",
        users: "Users",
        personalDetails: "Personal Details",
        accessDetails: "Access Details",
        accessControl: "Access Control",
        suspendedUsers: "Suspended Users",
        lockedUsers: "Locked Users",
        suspendedOn: "Suspended On",
        lockedOn: "Locked On",
        suspendedBy: "Suspended By",
        allowSiteAdminToConfigurePumpParameters:
          "Allow Site Admin to Configure Pump Parameters",
        allowSiteAdminToResetAndChangeSpareCounters:
          "Allow Site Admin to Reset and Change Spare Counters",
        allowSiteAdminToSeeActivityLog :
          "Allow site admin to View Activity Log",
        allowSiteAdminToSeeEnergySaving :
          "Allow site admin to View Energy Saving",
        selectParameter: "Select Parameter",
        country: "Country",
        zone: "Zone",
        allZone: "All Zone",
        east: "East",
        west: "West",
        south: "South",
        north: "North",
        central: "Central",
        marketingContent: "Marketing Content",
        healthCheck: "Health Check",
        marketingContentPreview: "Marketing Content Preview",
        regionalOffice: "Regional Office",
        pumpMasters: "Pump Masters",
        systemMasters: "System Masters",
        pumpsAndSystems: "Pumps & Systems",
        masters: "Masters",
        masterName: "Master Name",
        category: "Category",
        systemType: "System type",
        selectCategory: "Select Category",
        type: "Type",
        application: "Application",
        location: "Location",
        selectParametersToAddInTheMimicImage:
          "Select Parameters to add in the Mimic Image",
        parameter: "Parameter",
        outOfSyncParameters: " Parameters are out of sync",
        oneParameterIsOutOfSync: "1 Parameter is out of sync",
        noParametersAreOutOfSync: "No Parameters are out of sync",
        serialNumber: "Serial No :",
        thingKey: "Sensor Key :",
        invalidSensorKey : "Invalid Sensor Key",
        lastAlert : "Last Alert",
        todayRunHour : "Today's Run Hour",
        lastActivity : "Last Activity",
        online : "Live",
        offline : "Offline",
        off: "Pump is OFF",
        on: "Pump is ON",
        raisedOn: "Raised On",
        resolvedOn : "Resolved On",
        isMCurrOrDirunAltizonAttributePresent : "MCURR/DIRUN Missing",
        isMenrgAttributePresent : "Altizon Parameter MENRG Missing",
        missing : "Missing",
        pumpId : "Pump Id",
        thingTemplateName : "Thing Template",
        lastRefreshedTime : "As Of",
        ruleNotificationEvents : "Rule Notification Events",
        dignostics : "Dignostics",
        data : "Data",
        alerts : "Alerts",
        edit : "Edit",
        alertsCenter : "Alert Center",
        auditTrail : "Audit Trail",
        customerAndSite : "Customer & Site",
        currentValue : "Current Value",
        validValue : " (Valid Value)",
        loadingMessage : "Please wait, this may take few minutes",
        pumpModel: "Pump Model",
        healthyRange: "Healthy Range",
        alarmingRange: "Alarming Range",
        trippingRange: "Tripping Range",
        setValue: "Set Value",
        addNewPumpMaster: "Add New Pump Master",
        addNewSystemMaster: "Add New System Master",
        editPumpMaster: "Edit Pump Master",
        pumpMasterName: "Pump Master Name",
        systemMasterName: "System Master Name",
        systemDetails: "System Details",
        pumpDetails: "Pump Details",
        staticDetails: "Static Details",
        motorEngineDetails: "Motor/ Engine Details",
        parameters: "Parameters",
        shortDiscription: "Description",
        shortDescription: "Description",
        parameterThresholdConfiguration: "Parameter Threshold Configuration",
        parameterAlertFrequencyConfiguration:
          "Parameter Alert Frequency Configuration",
        SparesAlertFrequencyConfiguration:
          "Spares Alert Frequency Configuration",
        pumpApplication: "Pump Application",
        applicationCommonParameters: "Application Common Parameters",
        pump: "Pump",
        helpMaster: "Help Master",
        causeMatrix: "Cause Matrix",
        troubleShootingDetails: "Troubleshooting Details",
        spares: "Spares",
        sparesTriggerResetValues: "Spares trigger/ reset values",
        spareName: "Spare Name",
        helpDocuments: "Help Documents",
        mimicImageParameters: "Mimic Image Parameters",
        mimicImageAndParameters: "Mimic Image & Parameters",
        notificationFrequency: "Notification Frequency",
        highAlarmFrequencyHrs: "High alarm frequency (hrs)",
        mediumAlarmFrequencyHrs: "Medium alarm frequency (hrs)",
        mocCode: "MOC Code",
        standardTriggerValueForHighAlerts:
          "Standard  Trigger Value For High Alerts",
        standardTriggerValueForMediumAlerts:
          "Standard Trigger Value For Medium Alerts",
        standardTriggerValuesHrs: "Standard Trigger Value (hrs)",
        addNewSpare: "Add New Spare",
        forHighAlarm: "For High Alarm",
        forMediumAlarm: "For Medium Alarm",
        addNewCause: "Add New Cause",
        updateCause: "Update Cause",
        all: "All",
        pumpAndSystems: "Pumps & Systems",
        pumpAndSystemMasters: "Pumps & Systems Masters",
        troubleDelete: "Are you sure you want to delete this Trouble?",
        causeDelete: "Are you sure you want to delete this Cause?",
        remedyDelete: "Are you sure you want to delete this Remedy?",
        "Add New Cause": "Add New Cause",
        "Add New Remedy": "Add New Remedy",
        "Add New Trouble": "Add New Trouble",
        Cause: "Cause",
        Trouble: "Trouble",
        Add: "Add",

        language: {
          english: "English",
          hindi: "Hindi",
          russian: "Russian",
          french: "French",
          german: "German",
          spanish: "Spanish",
        },
        others: "Others",
        installationGuide: "Installation Guide",
        productBrochure: "Product Brochure",
        iom: "IOM",
        parameterName: "Parameter Name",

        unit: "Unit",
        mfmMultiFunctionMeter: "MFM - Multi Function meter",
        vdfVariableFrequencyDrive: "VDF - Variable frequency drive",
        calibration: "Calibration",
        from: "From",
        to: "To",
        threshold: "Threshold",
        MUCRRThresholdValueForPumpONOFFStatus: "MUCRR Threshold value for Pump ON/OFF Status",
        TrendGraphNotAvailable: "Trend Graph not available for digital parameter",
        range: "Range",
        singleValue: "Single Value",
        healthyRangeKgCm2: "Healthy Range (kg/cm2)",
        alarmingRangeKgCm2: "Alarming Range (kg/cm2) 1 - 1.07 & 1.76 - 3",
        highestValue: "Highest Value",
        lowestValue: "Lowest Value",
        notificationDelay: "Notification Delay",
        trippingRangeKgCm2: "Tripping Range (kg/cm2) 0 - 0.9 & 3.1 - 4",
        addParameterInCauseMetricsOptional:
          "Add Parameter in Cause Matrix (Optional)",
        causeMetrics: "Cause Matrix",
        upperAlarming: "Upper Alarming",
        lowerAlarming: "Lower Alarming",
        true: "True",
        false: "False",
        causeEffectMatrix: "Cause Effect Matrix",
        metrics: "Metrics",
        valid: "Valid",
        altizonParameters: "Altizon Parameters",
        kblParameters: "KBL Parameters",
        parametersRange: "(low-high)",
        condition: "Condition",
        mtrFrequency: "Mtr Frequency",
        mtrVolt: "Mtr Volt",
        mtrCurr: "Mtr Curr",
        mtrPower: "Mtr Power",
        mtrPowerFactor: "Motor Power Factor",
        dischargePressure: "Discharge Pressure",
        suctionPressure: "Suction Pressure",
        flow: "Flow",
        mtrDEBearingTemp: "Mtr DE Bearing Temp",
        mtrNDEBearingTemp: "Mtr NDE Bearing Temp",
        mtrWindingTemp: "Mtr Winding Temp",
        pmpDEBearingTemp: "Pmp DE Bearing Temp",
        pmpNDEBearingTemp: "Pmp NDE Bearing Temp",
        mtrDEBearingVibr: "Mtr DE Bearing Vibr",
        mtrNDEBearingVibr: "Mtr NDE Bearing Vibr",
        pmpDEBearingVibr: "Pmp DE Bearing Vibr",
        pmpNDEBearingVibr: "Pmp NDE Bearing Vibr",
        lower: "Lower",
        upper: "Upper",
        probableCause: "Probable Cause",
        notification: "Notification",
        addNewFaq: "Add new FAQ",
        selectOrCreateNewFaqCategory: "Select or create new FAQ Category",
        question: "Question",
        answer: "Answer",
        troubles: "Troubles",
        causes: "Causes",
        trouble: "Trouble",
        cause: "Cause",
        remedy: "Remedy",
        linkForYes: "Link for YES",
        linkForNo: "Link for No",
        selectCause: "Select cause",
        remedyForAboveCause: "Remedy for above cause",
        attachments: "Attachments",
        addNewTroubleshootingGuide: "Add New Troubleshooting Guide",
        selectOrCreateTrouble: "Select or create Trouble",
        cancel: "Cancel",
        add: "Add",
        addNew: "Add New",
        value: "Value",
        atLeastOneCategoryShouldBeSelected:
          "At least one category should be selected",
        userAndRoles: "Users & Roles",
        logo: "Customer Logo(Optional)",
        remark: "Pump/System Remark",
        reportCustomizationScheduler: "Report Customization Scheduler",
      },
      adminMenu: {
        userManagement: "USER MANAGEMENT",
        customerManagement: "CUSTOMER MANAGEMENT",
        settingAndConfiguration: "SETTINGS & CONFIGURATION",
        customerAndSites: "Customers & Sites",
        causeEffectMatrix: "Cause Effect Matrix",
      },
      complaint: {
        complaints: "Complaints",
      },
      members: {
        members: "Members",
      },
      mySites: {
        mySites: "My Sites",
        members: "Members",
        siteDetails: "Site Details",
        inviteMember: "Invite Member",
        access: "Access",
        sendInvite: "Send Invite",
        approvalPending: "Approval Pending",
        admin: "Admin",
        viewOnly: "View Only",
        active: "Active",
        inactive: "Inactive",
        addMobileNo: "Please Add Mobile Number with Country Code",
        canViewActivityLog:"Give Access to View activity log",
        canViewEnergySaving:"Give Access to View EnergySaving"
      },
      subscriptions: {
        subscriptions: "Subscriptions",
      },
      sortFactorList: {
        numberOfAlerts: "Number of Alerts",
        numberOfPumps: "Number of Pumps",
        alphabetically: "Alphabetically",
      },
      activityLog: {
        title: "Activity Log",
        description: "Log of alerts, spares, actions, etc",
        noLogs: "Nothing happened yet",
        tabs: {
          all: "All",
          alerts: "Alerts",
          alarm: "Alarms",
          pump: "Pump",
          notification: "Notifications",
        },
      },
    },
    MESSAGES: {
      Error: {
        pumpDeactivated: `This pump is deactivated, please contact your administrator`,
        emailNotRegistered: `Account does't exist.`,
        incorrectPassword: "Incorrect password",
        incorrectCredentials:
          "Login failed. Please review your credentials and retry.",
        spareNameIsRequired: "Spare name is Required!",
        mocCodeIsRequired: "MOC Code is Required!",
        remarkIsRequired: "Remark is Required!",
        descriptionIsRequired: "Description is Required!",
        maxLengthExceedRemark: "The maximum character limit is 250",
        maxLengthExceedSpare: "The maximum character limit is 700",
        fiveMBMaxSize: "Maximum file size allowed for upload: 5 MB",
        onlyUploadImage: "Please Upload Image only",
        highAlarmFrequencyIsRequired: "High alarm frequency  is Required!",
        L0001: `Account does't exist.`,
        L0002: "Incorrect password",
        L0003: "User is deactivated. Please contact to admin",
        L0004:
          "Subscription had been expired, to renew the Subscription Please contact KBL Team",
        L0005:
          "Cannot login as no pumps/systems are assigned, Please contact KBL team",
        userAccountIsLocked:
          "Due to 5 failed login attempts your account has been locked, try again after 30 mins or contact administrator to login to the application",
        invalidOTP: "OTP is incorrect",
        expiredOTP: "OTP is expired",
        failedOTPSend: "Failed to resend OTP. Please try again later.",
        resetPasswordForKBLUser:
          "Please reset the password from KBL Active Directory & re-login with new password",
        kblLoginServerNotResponse:
          "It seems like we're unable to process your login right now. The authentication server is currently unavailable. Please reach out to the administrator for assistance or try logging in again later. We apologize for any inconvenience.",
        enterCorrectOldPassword: "Please enter correct old password",
        mediumAlarmFrequencyIsRequired: "Medium alarm frequency  is Required!",
        validContact: "Please enter the valid Mobile/Phone Number",
        validName: "Please enter valid name",
        validNumber: "Please enter number without decimal",
        noDataFound: "No data found",
        negativeValue: "Value should not be less than 0",
        noDecimal: "Value should not be decimal",
        nonZero: "Value should not be zero",
        oneDay: "value should within 1 to 1440",
        fiveMinToOneDay: "value should within 5 to 1440",
        required: "Required",
        internetConnectivityHasBeenLost:
          "Internet connectivity has been lost, please check internet connection and retry your last action",
        noUserAccess:
          "Please contact your Admin to get the access to this functionality.",
        addMobileWithCountry: "Please Add Mobile Number with Country Code",
        requiredName: "Name is required.",
        requiredCondition: "Condition Is Required",
        requiredProbableCause: "Probable Cause Is Required",
        requiredRemedy: "Remedy Is Required",
        requiredNotification: "Notification Is Required",
        lessThan500Characters: "Please Enter Less Than 500 Characters",
        lessThan1000Characters: "Please Enter Less Than 1000 Characters",
        atLeastOneParameter: "Please Select At Least One Parameter Combination",
        atLeastLowerUpper: "Please Select At Least Lower Or Upper",
        mimicImageResolution:
          "Image is of not supported resolution. Supported image resolutions are 1280px X 720px for horizontal image & 1280px X 1440px for vertical image",
        specialCharactersNotAllowed: "Special characters are not allowed",
        aplhabetsAndSpacesOnly: "Only alphabets and spaces are allowed",
        addressRegexValidation:
          "Allowed special characters are .,/()-& and spaces",
        invalidInput: "Invalid input",
        fileIsNotValidImageFormat:
          "Unsupported file format. Please upload only png, jpg, jpeg files.",
        fileIsNotValidPdfFormat:
          "Unsupported file format. Please upload only pdf files.",
          invalidFileFormat:
          "Unsupported file format. Please upload only pdf, jpg, jpeg and png files.",
        filePixelSizeNotMatch:
          "Image is not of supported resolution. Supported image resolutions are 1280x720 for horizontal image and 1280x1440 for vertical image.",
        fileSizeExceededForPdf:
          "The file is too large. Please upload files of size upto 5MB",
        fileSizeExceededForImage:
          "The image is too large. Please upload image of size upto 5MB",
        fileUploadLimit: "The limit of uploading maximum 10 files reached",
        fileUploadLimit9: "The limit of uploading maximum 9 files reached",
        fileUploadFailed: "File upload failed?",
        onlyAlphabetsAndSpaces: "Only alphabets and spaces are allowed",
        alphanumericAndSpacesOnly: "Only alphanumeric and spaces are allowed",
        alphanumericAndSpecialCharacters:
          'Allowed Special characters are .,/ " ; : - _ | #',
        alphanumericSpacesAndSlash:
          "Only alphanumeric, spaces and slash (/) is allowed",
        causeMatrixRegex: "Special characters allowed are .,/()-+& and spaces",
      },
      adminPump: {
        model: "Pump model delete of id ",
        duplicate: "Pump model duplicated of id ",
        parameter: "Parameter deleted of id ",
        deletePump: "Are you sure you want to delete this Pump Master?",
        deleteParameter: "Are you sure you want to delete this Pump Parameter?",
        deleteSpare: "Are you sure you want to delete this Spare?",
        deleteMimicImage: "Are you sure you want to delete this mimic image?",
        deleteSystemMaster:
          "Are you sure, you want to delete $deleteItemName system master?",
        deleteItem:
          "Are you sure, you want to delete $deleteItemName $deleteItemCategory?",
        removeItem:
          "Are you sure, you want to remove $deleteItemName $deleteItemCategory?",

          deactivateItem:
          "Are you sure, you want to deactivate $deleteItemName $deleteItemCategory?",

          activateItem:
          "Are you sure, you want to activate $deleteItemName $deleteItemCategory?",

        atLeastOnePumpShouldBeSelected: "At least one pump should be selected",
        pleaseSelectCustomerAndSite: "Please select customer and site",
        noMatchingPumpsAndSystems:
          "No matching Pump or System available in the application",
        noMatchingPumpMasters:
          "No matching Pump master available in the application.",
        noMatchingSystemMasters:
          "No matching System master available in the application.",
        mimicImageRatioMessage:
          "For proper visibility, please add images in the dimensions of 1280px X 720px" +
          " or 1280px X 1440px.",
      },
      error: "Error",
      toaster: {
        error: "Error",
        success: "Success",
        information: "Information",
        warning: "Warning",
      },
      is: "is",
      language: {
        languageNotAvailable: "Language not available",
      },
      auth: {
        emailIs: "Email is",
        required: "Required",
        invalidUrl: "Invalid url",
        emailIsRequired: "Email is required",
        enterValidEmail: "Please enter a valid email address",
        passwordIsRequired: "Password is required",
        confirmPasswordIsRequired: "Confirm password is required",
        standardPasswordRequired: "Password doesn't match standard format",
        passwordMustContain:
          "Password should contain minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character",
        passwordStrengthPoor: "Password strength: Poor",
        passwordNotMatching: "Passwords must match",
        tokenNotAvailable: "Token is not available",
        termsAgree: "I agree to Kirloskar Brothers’s",
        privacyPolicy: "Privacy Policy",
        termsOfUse: "Terms of Use",
        emailLink:
          "You must have received a reset link on above email address.",
        linkIsExpired: "Sorry, the link has expired",
        invalidRange: "Please enter a valid range",
        invalidValue: "Please enter a valid value",
        agreePrivacyPolicyAndTerms:
          "Agree Privacy Policy & Terms of use required",
        setPasswordEmail:
          "Reset link sent successfully to the given email address. Please check your inbox.",
        userIsDeactivated:
          "You are deactivated currently please contact your admin",
        containValidWord: 'Value must contain "VALID"',
        notContainValidWord: 'Value should not contain "VALID"',
        otpVerificationMessage:
          "Please enter the One Time Password(OTP) sent to",
        or: "or",
        notReceiveOTP: "Did not receive OTP?",
        alphanumericAndSpacesOnly: "Only alphanumeric and spaces are allowed",
        invalid: "Invalid",
        invalidUnit: "Invalid unit",
        alphabetAndSpaces: "Only alphabets and spaces are allowed",
        numbersOnly: "Only numbers are allowed",
        validRunHoursFormat: "Only numbers are allowed in the format HH:MM, with hours in any range and minutes from 00 to 59.",
        alphanumericSpacesParenthesisAndHypen:
          "Only () and - special characters allowed",
          alphanumericSpacesParenthesisHypenDotAndComma:
          "Only & , . () and - special characters allowed",
          alphanumericSpacesParenthesisCommaSlashAndHypen:
          "Only () , / and - special characters allowed",
      },
      help: {
        deleteFaq: "Are you sure you want to delete this FAQ?",
      },
      role: {
        deleteRole: "Are you sure you want to delete this Role?",
      },
      user: {
        deactivateUser: "Are you sure you want to deactivate this user?",
        suspendUser: "Are you sure you want to suspend this user?",
        deleteSuspendedUser: "Are you sure you want to delete this suspended user?",
        deleteDeactivatedUser: "Are you sure you want to delete this deactivated user?",
        cannotDeleteActiveUser:"You cannot delete an active user. Please deactivate the user first.",
      },
      site: {
        deactivate: "Are you sure you want to deactivate this site?",
        enterValidLocation: "Please enter valid Latitude and Longitude",
      },
      noDataAvailable: "No data available",
      oopsNoDataFound: "Oops...No data found.",
      noAlertsGeneratedForSite: "No alerts generated for the site",
      noFiltersAvailable: "No filters available",
      noDocumentsAdded: "No documents added.",
      noParametersAvailable: "No parameters available",
      noMimicAvailable: "No mimic image available.",
      noReportsGenerated: "No reports generated yet.",
      noSparesAvailable: "No spares available",
      noSitesAssigned: "No sites assigned to you yet",
      pump: {
        fromDateShouldBeLessThanEndDate:
          "From date should be less than To date",
           fromDateToDateDifferenceCannotBeMoreThanOneYear:
          "Difference between From and To cannot be more than 1 year",
        selectDays: "Maximum Report Period can be 1 Month",
        maximum24HourPeriodAllowed:
          "Maximum 24 hours period allowed",
        notActive: "Inactive",
        notAvailable: "Unavailable",
        youHaveANewAlert: "You have a new alert",
        noCauseMatrix: "No cause matrix condition detected yet",
      },
      spare: {
        runCounterUpdatedSuccessfullyFor:
          "Run counter updated successfully for ",
        extendedTriggerValueUpdatedSuccessfullyFor:
          "Extended trigger value updated successfully for ",
        userSetValueUpdatedSuccessfullyFor:
          "User set value updated successfully for ",
        validUserSetValue: "Please enter a valid User Set Value",
        validUserSetValue1: "Maximum limit of 6 digits has been reached.",
        validUserSetValue2: "Maximum limit of 7 digits has been reached.",
        ZeroUserSetValue: "User Set Value cannot be 0.",
        nullUserSetValue: "User Set Value cannot be null."
      },
      confirmationMessage: {
        muteNotification:
          "You will not get any SMS, Emails & Push notifications till $timePeriod from now. Do you still want to mute notifications for $parameterName?",
      },
      fileDownloaded: "File downloaded successfully.",
      invitationSent: "The invitation email is been sent to the user",
      isOTPSent: "OTP Sent",
      reportSent: "Report sent successfully.",
      QuoteSent: "Quote has been requested successfully.",
      reportRequested:
        "Request is been submitted. Report will be sent in few minutes.",
      reportSaveRequested:
        "Request has been submitted. Report will be saved in Downloads folder in few minutes.",
      parameter: {
        addHotspot: "Add Hotspot on Mimic image",
        addHotspotOptionSelectInfo:
          "Selecting this, you can add a hotspot i.e location of the parameter on the mimic image",
        showParameterOnPumpDashboard: "Show on System's Dashboard",
        showParameterOnPumpDashboardInfo:
          "Selecting this, you can monitor this parameter on the System's dashboard.",
        addParameterInCauseMatrixOptional:
          "Add Parameter in Cause Matrix (Optional)",
        generateAlert: "Generate Alert",
        generateAlertInfo:
          "Selecting this, alert will generated when the parameter has tripping value.",
      },
      noCustomersAndSitesAdded: "No customers & sites added yet",
      noUserSuspended: "No user has been suspended yet",
      noUserLocked: "No user has been locked yet",
      noImageAdded: "No image added yet",
      noSpareDemand: "There is no spare demand for this period",
      noCauseCondition: "There is no cause condition detected for this period",
      noRemarksAdded: "No remarks added yet",
      pumpRemark: {
        publishRemark: {
          title: "Publish Remarks",
          message:
            "Once the selected remarks are published, they cannot be unpublished or deleted. Do you still want to publish?",
        },
        addRemark: {
          addNewRemark: "Add New Remark",
        },
      },
      information: {
        detail1: "\"MCURR Threshold\" value is applicable only If \"MCURR\" cloud attribute is available for pump. If value of MCURR is less than Threshold value pump will be treated as OFF else it will be treated as ON.",
        detail2: "If \"MCURR\" cloud attribute is not available for pump but \"DIRUN\" cloud attribute is available for pump then \"DIRUN\" attribute value will be used for Pump ON/OFF (ON - 1, OFF - 0). In this case Threshold value will not come in picture.",
        detail3: "If both the cloud attributes \"MCURR\" and \"DIRUN\" is missing for pump then Pump ON/OFF logic will not work so it is mandatory to have one of this attribute defined for Pump."
      }
    },
    PLACEHOLDERS: {
      selectPump: "Pump",
      selectSite: "Select Site",
      selectCustomer: "Select Customer",
      selectCauseMatrix: "Select cause matrix",
      selectMaster: "Select Master",
      searchByCustomer: "Search By Customer",
    },
  },
};
